<template>
  <transition name="el-fade-in-linear">
    <div class="wiseBrain">
      <div class="firstWiseBrain">
        <div class="firstItemWiseBrain">
          <img
            class="shutterstockWiseBrain"
            src="../../static/images/shutterstockWiseBrain.png"
          />
        </div>
        <div class="firstItem1WiseBrain">
          <div class="firstWiseBrainTitle">WiseBrain</div>
          <div class="firstWiseBrainTitleLittle">智能决策引擎</div>
          <div class="firstWiseBrainText">
            WiseBrain是面向场景智能决策引擎的平台框架，提供WiseBrain Data,
            WiseBrain Computing, WiseBrain Gallery, WiseBrain
            TopoEngine等功能，旨在解决个性化服务客户，产品快速响应，运维效率提升，开发组件复用等问题。
          </div>
        </div>
      </div>
<div class="secondWiseBrain" >
      <img src="../../static/images/wiseBrain03.png" class="secondWiseBrainImg"/>
  
</div>
      <img
        src="../../static/images/wiseBrain02.png"
        class="thirdWiseBrainTitle"
      />

      <div class="thirdWiseBrain">
        <div class="thirdItemWiseBrain">
          <img
            class="thirdIconImgWiseBrain"
            src="../../static/images/wiseBrainIcon0.png"
          />
          <div class="thirdIcon1TextWiseBrain">
            智能化AI赋能快速响应碎片化数据分析需求
            数据分析需求即时下达，WiseBrain具备快速AI赋能能力，智能化AI分析应用开发更显迅速，令AI应用唾手可得
          </div>
        </div>

        <div class="thirdItemWiseBrain thirdItemWiseBrainMargin">
          <img
            class="thirdIconImgWiseBrain"
            src="../../static/images/wiseBrainIcon1.png"
          />
          <div class="thirdIcon1TextWiseBrain">
            智能化知识推理高效助力探索数据奥秘（智能化知识推理解放数据生产力）需求碎片多样，数据异源繁杂，基于WiseBrain对应用的抽象以及多源数据的融合，结合其中的知识推理引擎对您的大数据进行随心所欲的探索，发现不一样的奥秘
          </div>
        </div>
        <div class="thirdItemWiseBrain thirdItemWiseBrainMargin">
          <img
            class="thirdIconImgWiseBrain"
            src="../../static/images/wiseBrainIcon2.png"
          />
          <div class="thirdIcon1TextWiseBrain">
            智能化平台运维显著增强AI分析更显可靠
            WiseBrain具备自动伸缩和智能容灾能力等“自动驾驶”能力，能够自适应不断变化的实际应用以及计算需求，面对不断增长的业务以及数据，更显从容
          </div>
        </div>
      </div>
      <img
        src="../../static/images/wiseBrain01.png"
        class="fourthWiseBrainImg"
      />

      <div class="fourthWiseBrain">
        <div class="fourthItemWiseBrain">
          <img
            class="thirdIconImgWiseBrain"
            src="../../static/images/wiseBrainIcon3.png"
          />
          <div class="thirdIcon1TitleWiseBrain">需求场景分解与应用集成编排</div>
          <div class="thirdIcon1TextWiseBrain">
            对繁杂的业务需求场景进行分解，抽象出业务应用集合，通过多个应用的编排组合，实现对需求变化的快速响应以及迭代，其中WiseBrain
            TopoEngine能够驱动数据像血液在多个场景的应用拓扑中流动，赋能WiseBrain像大脑一样思考
          </div>
        </div>
        <div class="fourthItemWiseBrain fourthItemWiseBrainMargin">
          <img
            class="thirdIconImgWiseBrain"
            src="../../static/images/wiseBrainIcon4.png"
          />
          <div class="thirdIcon1TitleWiseBrain">算法即服务与AI赋能</div>
          <div class="thirdIcon1TextWiseBrain">
            在实际业务中，随着数据的增长，AI算法需要进行及时的更新以及调优，WiseBrain
            Computing支持算法服务的快速变更以及自动伸缩能力，能够快速且无缝地完成AI算法升级迭代
          </div>
        </div>
        <div class="fourthItemWiseBrain fourthItemWiseBrainMargin">
          <img
            class="thirdIconImgWiseBrain"
            src="../../static/images/wiseBrainIcon5.png"
          />
          <div class="thirdIcon1TitleWiseBrain">场景知识图谱的构建与推理</div>
          <div class="thirdIcon1TextWiseBrain">
            对业务的场景集合进行分解得到知识对象，并建立知识对象的关系图谱以及映射，通过WiseBrain
            Gallery对关系图谱的计算以及推理，轻松满足对于业务数据的分析以及探索
          </div>
        </div>
        <div class="fourthItemWiseBrain fourthItemWiseBrainMargin">
          <img
            class="thirdIconImgWiseBrain"
            src="../../static/images/wiseBrainIcon6.png"
          />
          <div class="thirdIcon1TitleWiseBrain">数据治理与数据驱动</div>
          <div class="thirdIcon1TextWiseBrain">
            数据的爆炸性增长带来了繁复的数据管理问题，WiseBrain
            Data提供了多样的即时可得的数据接入方式，并且融合数据质量以及数据权限等数据治理特性，让客户对数据的管控更加轻松
          </div>
        </div>
      </div>
      <div class="wiseBrainFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";
export default {
  name: "WiseBrain",
  data() {
    return {};
  },
  mounted: function () {
  },
  components: {
    Foot,
  },
  methods: {},
};
</script>
<style scoped>
@import "./WiseBrain.css";
</style>



// WEBPACK FOOTER //
// src/views/WiseBrain.vue